import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { getCertificate } from "../../modules/actions";
import "./header.scss";

function SearchModal(props) {
	const [search, setSearch] = useState("");
	const [certificateData, setCertificateData] = useState("");
	useEffect(() => {
		if (props.match.params.entryNumber) {
		}
	}, [props.match.params]);

	useEffect(() => {
		setCertificateData(props.certificate);
	}, [props.certificate]);
	console.log(certificateData);

	const searchCert = () => {
		window.open(`https://certificates.ggilab.com/?entries=${search}`, "_blank");
		// props.history.push(`/Certificate/${search}`)
		// props.setSearchOpen('0')
		// props.getCertificate(search);
	};

	// useEffect(() => {
	// 	if (search) {
	// 		console.log(certificateData);
	// 		console.log("runn");
	// 		let data = search.slice(0, 2);
	// 		let peshawarData = search.slice(0, 3);
	// 		if (data.toLowerCase() === "ld") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup1/printdgproduct.php?product_code=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "mg") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup1/printgmproduct-mcc.php?product_code=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "sj") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup1/print-s-jew.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "sg") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup1/print-gems-s-jew-old.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "sd") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup1/print-s-dia.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "lj") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup1/jewelleryReportCertificate.php?id=${
	// 					certificateData.id
	// 				}&certificateId=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "la") {
	// 			window.open(
	// 				`https://ggilab.com/newsetup1/appraisalCertificate.php?appraisal=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 						? certificateData.certificateNumber
	// 						: certificateData.certificate_no
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "se") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup1/print-gems-s-jew.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		} else if (peshawarData.toLowerCase() === "pld") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup2/printdgproduct.php?product_code=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (peshawarData.toLowerCase() === "pmg") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup2/printgmproduct-mcc.php?product_code=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (peshawarData.toLowerCase() === "psj") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup2/print-s-jew.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		} else if (peshawarData.toLowerCase() === "psg") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup2/print-gems-s-jew-old.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		} else if (data.toLowerCase() === "sd") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup2/print-s-dia.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		} else if (peshawarData.toLowerCase() === "plj") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup2/jewelleryReportCertificate.php?id=${
	// 					certificateData.id
	// 				}&certificateId=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (peshawarData.toLowerCase() === "pla") {
	// 			window.open(
	// 				`https://ggilab.com/newsetup2/appraisalCertificate.php?appraisal=${
	// 					certificateData.entryNo
	// 						? certificateData.entryNo
	// 						: certificateData.number
	// 						? certificateData.number
	// 						: certificateData.certificateNumber
	// 						? certificateData.certificateNumber
	// 						: certificateData.certificate_no
	// 				}`,
	// 				"_blank"
	// 			);
	// 		} else if (peshawarData.toLowerCase() === "pse") {
	// 			window.open(
	// 				`https://checking.ggilab.com/newsetup2/print-gems-s-jew.php?product_code=${certificateData.Id_of_temp_data}`,
	// 				"_blank"
	// 			);
	// 		}
	// 	}
	// }, [certificateData]);

	return (
		<div className="SearchModal">
			<label>
				<input
					placeholder="ENTER CERTIFICATE NO ."
					onChange={(ev) => setSearch(ev.target.value)}
					onKeyPress={(event) => {
						if (event.key === "Enter") {
							searchCert();
						}
					}}
				/>
				<button onClick={() => searchCert()}>
					<FiSearch />
				</button>
			</label>
		</div>
	);
}

const mapStateToProps = ({ store }) => ({
	certificate: store.certificate
});

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getCertificate
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchModal));
